import React, { useEffect } from "react";
import { useNavigate } from 'react-router-dom';

const Hero = ({ selectedServices }) => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col items-center mx-auto">
            {/* Dropdown for mobile */}
            <div className="w-full md:hidden">
                <select
                    className="form-select  w-full md:w-[70rem] px-5 py-[1px] text-lg xl:text-2xl rounded-full border border-gray-300"
                    value={selectedServices}
                    onChange={(e) => {
                        const value = e.target.value;
                        navigate(value === "All" ? "/explore" : `/explore/${value}`);
                    }}
                    style={{ paddingRight: "4rem" }} // Increased right padding to avoid overlap
                >
                    <option value="essentials">Essential Services</option>
                    <option value="all">All Apps & Solutions</option>
                    <option value="custom">Custom Solutions</option>
                </select>
            </div>

            {/* Buttons for larger screens */}
            <div className="hidden md:grid mt-[10px] w-[700px] 2xl:w-[900px] bg-exploreNavBackground grid-cols-3 gap-4 h-fit rounded-full justify-between mx-4 xs:mx-8 md:mx-[20px] p-[4px]">
                <button
                    className={`${selectedServices === "essentials" ? 'text-exploreNavTextSelected bg-exploreNavBackgroundSelected font-[600]' : 'text-exploreNavText bg-exploreNavBackground font-[400]'} text-[19px] font-proximanova py-[1px] px-[8px]   2xl:px-[24px] rounded-full transition-all duration-300`}
                    onClick={() => navigate("/explore/essentials")}
                >
                    Essential Services
                </button>
                <button
                    className={`h-fit ${selectedServices !== "essentials" && selectedServices !== "custom" ? 'text-exploreNavTextSelected bg-exploreNavBackgroundSelected font-[600]' : 'text-exploreNavText bg-exploreNavBackground font-[400]'} text-[19px] font-proximanova py-[1px] px-[8px] 2xl:px-[24px] rounded-full transition-all duration-300`}
                    onClick={() => navigate("/explore/category/all")}
                >
                    All Apps & Solutions
                </button>
                <button
                    className={`h-fit ${selectedServices === "custom" ? 'text-exploreNavTextSelected bg-exploreNavBackgroundSelected font-[600]' : 'text-exploreNavText bg-exploreNavBackground font-[400]'} text-[19px] font-proximanova py-[1px] px-[8px] 2xl:px-[24px] rounded-full transition-all duration-300`}
                    onClick={() => navigate("/explore/custom")}>
                    Custom Solutions
                </button>
            </div>
        </div>
    );
}

export default Hero;